import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { useForm } from "react-hook-form";
import { useQuery } from "react-query";
import { useEffect, useState } from "react";
//components
import Panel from "../../../../../components/panel/panel";
import Select from "../../../../../components/input/Select";
import Input from "../../../../../components/input/Input";
//services
import { getOwner } from "../../../../../services/GlobalRoles/getOwner";
import { getAccount } from "../../../../../services/Banks/getAccount";
import { putAccount } from "../../../../../services/Banks/putAccount";
import { postAccount } from "../../../../../services/Banks/postAccount";
//primereact
import { Button } from "primereact/button";
import { Skeleton } from "primereact/skeleton";
import { BreadCrumb } from "primereact/breadcrumb";
import { TabPanel, TabView } from "primereact/tabview";
import { useAppContext } from "../../../../../context/AppContext";
import NumberInput from "../../../../../components/input/NumberInput";

export function Safra() {
  const { id } = useParams();
  const { state } = useLocation();
  const navigate = useNavigate();

  const items = [
    {
      template: () => (
        <Link to={`/banks/${id}`} className="p-breadcrumb-link">
          Homologação
        </Link>
      ),
    },
    {
      template: "Banco Safra",
    },
  ];

    const home = {
    template: () => (
      <Link to={"/salesManagement"} className="p-breadcrumb-link">
        <i className="fa fa-home"></i>
      </Link>
    ),
  };


  const form = useForm();
  const errors = form.formState.errors;
  const setValue = form.setValue;

  const [radioButton, setRadioButton] = useState("percent");

  const [activeIndex, setActiveIndex] = useState(0);
  const [ownersSelect, setOwnersSelect] = useState([]);
  const [currentData, setCurrentData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const { permissions } = useAppContext();
  const { data: owners, isLoading: loadingOwners } = useQuery({
    queryKey: [`owners${id}`],
    queryFn: () => getOwner(),
    enabled: !!permissions?.includes("59")
  });

  const { data: accountData, isLoading: loadingAccData } = useQuery({
    queryKey: [`accountData${id}`],
    queryFn: () => getAccount(state.accountId),
    enabled: !!state.edit && !!permissions?.includes("147"),
  });

  // const { data: discountData, isLoading: loadingDiscData } = useQuery({
  //   queryKey: [`discountData${id}`],
  //   queryFn: () => getAccountDiscount(id),
  // });

  const filterWhoSends = (who) => {
    let whoSend;
    switch (who) {
      case "Cliente envia boletos":
        whoSend = "client"
        break;
      case "Banco Envia Boleto":
        whoSend = "bank"
        break;
    }
    return whoSend;
  }

  useEffect(() => {
    if (accountData && state.edit) {
      setValue("user_id", accountData.company.id);
      setValue("who_sends", filterWhoSends(accountData.who_sends));
      setValue("days_to_clean", accountData.days_to_clean);
      setValue("seq_shipping", accountData.seq_shipping);

      setValue("agency", accountData.agency);
      setValue("agency_digit", accountData.agency_digit);
      setValue("account_number", accountData.account_number);
      setValue("account_digit", accountData.account_digit);
      setValue("cedente", accountData.cedente);
      setValue("wallet", accountData.wallet);
      setValue("wallet_variation", accountData.wallet_variation);
      setValue("beneficiary_code", accountData.beneficiary_code);
    }

    // if (discountData && state.edit) {
    //   setRadioButton(discountData.typeDescount.toString())
    //   setValue("percent", discountData.percent);
    //   setValue("value_discount", discountData.valueDescount);
    //   setValue("days_discount_payment_slip", discountData.days_discount_payment_slip);
    // }
//    console.log(accountData);
  }, [accountData]);

  useEffect(() => {
    if (owners) {
      const selectDataOwners = owners.map((owner) => ({
        value: owner.id,
        label: `${owner.name} - ${owner.doc}`,
      }));
      setOwnersSelect(selectDataOwners);
    }
  }, [owners]);

  const onSubmit = async (data) => {
    if (state && state.edit) {
      await updateAccount(data);
    } else {
      await createAccount(data);
    }
  };

  // const onDiscountSubmit = async (data) => {
  //   await createEditDiscount(data);
  // };

  async function createAccount(data) {
    const notification = toast.loading("Por favor aguarde...");
    const sendData = {
      bank: "422",
      agency: data.agency.toString(),
      agency_digit: parseInt(data.agency_digit),
      wallet: data.wallet.toString(),
      wallet_variation: data.wallet_variation,
      account_number: data.account_number.toString(),
      account_digit: parseInt(data.account_digit),
      who_sends: data.who_sends ? data.who_sends : "client",
      user_id: data.user_id,
      opening_balance: 0.0,
      days_to_clean: data.days_to_clean,
      seq_shipping: data.seq_shipping,
      beneficiary_code: data.beneficiary_code,
    };
//    console.log(sendData);

    const response = await postAccount(sendData);
//    console.log(response[0].success);
    if (response[0].success) {
      toast.update(notification, {
        render: response[0].success,
        autoClose: 5000,
        type: "success",
        isLoading: false,
      });
      // setActiveIndex(1);
      setCurrentData(response[0].data);
      navigate(`/banks/${id}`);
    } else {
      toast.update(notification, {
        render: "Oops, algo deu errado. Tente novamente!",
        autoClose: 5000,
        type: "error",
        isLoading: false,
      });
    }
  }

  async function updateAccount(data) {
    setIsLoading(true);
    const notification = toast.loading("Por favor aguarde...");
    const sendData = {
      bank: "422",
      agency: data.agency.toString(),
      agency_digit: parseInt(data.agency_digit),
      wallet: data.wallet.toString(),
      wallet_variation: data.wallet_variation.toString(),
      account_number: data.account_number.toString(),
      account_digit: parseInt(data.account_digit),
      who_sends: data.who_sends ? data.who_sends : "client",
      user_id: data.user_id,
      opening_balance: 0.0,
      days_to_clean: data.days_to_clean,
      seq_shipping: data.seq_shipping,
      beneficiary_code: data.beneficiary_code,
    };
    const response = await putAccount(state.accountId, sendData);
    if (response.success) {
      toast.update(notification, {
        render: response.success,
        autoClose: 5000,
        type: "success",
        isLoading: false,
      });
      // setActiveIndex(1);
    } else {
      toast.update(notification, {
        render: "Oops, algo deu errado. Tente novamente!",
        autoClose: 5000,
        type: "error",
        isLoading: false,
      });
    }
    setIsLoading(false);
  }

  // async function createEditDiscount(data) {
  //   const notification = toast.loading("Por favor aguarde...");
  //   if (currentData && currentData.id) {
  //     const sendData = {
  //       "enterprise_id": id,
  //       "current_account_id": currentData.id,
  //       "type_descount": radioButton,
  //       "value_descount": data.value_discount,
  //       "days_discount_payment_slip": data.days_discount_payment_slip,
  //       "percentage_transfer_installment": 0
  //     };

  //     const response = await postAccountDiscount(sendData);
  //     if (response.success) {
  //       toast.update(notification, {
  //         render: response.success,
  //         autoClose: 5000,
  //         type: "success",
  //         isLoading: false,
  //       });
  //       setActiveIndex(1);
  //     } else {
  //       toast.update(notification, {
  //         render: "Oops, algo deu errado. Tente novamente!",
  //         autoClose: 5000,
  //         type: "error",
  //         isLoading: false,
  //       });
  //     }
  //   } else if (state && state.edit) {
  //     const sendData = {
  //       "enterprise_id": id,
  //       "current_account_id": accountData.id,
  //       "type_descount": radioButton,
  //       "value_descount": data.value_discount,
  //       "days_discount_payment_slip": data.days_discount_payment_slip,
  //       "percentage_transfer_installment": 0
  //     };

  //     const response = await postAccountDiscount(sendData);
  //     if (response.success) {
  //       toast.update(notification, {
  //         render: "Descontos atualizados com sucesso!",
  //         autoClose: 5000,
  //         type: "success",
  //         isLoading: false,
  //       });
  //       setActiveIndex(1);
  //     } else {
  //       toast.update(notification, {
  //         render: "Oops, algo deu errado. Tente novamente!",
  //         autoClose: 5000,
  //         type: "error",
  //         isLoading: false,
  //       });
  //     }
  //   }
  //   else {
  //     toast.warning("Você precisa cadastrar uma conta antes...");
  //   }
  // };

  return (
    <>
      <div>
        <BreadCrumb
          model={items}
          home={home}
          style={{
            background: "transparent",
            border: "none",
            fontSize: "16px",
          }}
        />
      </div>
      {loadingAccData && state.edit ? (
        <Skeleton width="100%" height="80vh" />
      ) : (
        <Panel title="Homologação Bancária">
          <TabView
            activeIndex={activeIndex}
            onTabChange={(e) => setActiveIndex(e.index)}
            className="meu-tabview pt-3"
          >
            <TabPanel
              header="Configurações Integração"
              leftIcon="pi pi-wallet mx-2"
            >
              <form onSubmit={form.handleSubmit(onSubmit)}>
                <div className="flex align-items-center pt-2">
                  <h3 className="vertical-align-middle text-success">
                    Configurações da Conta
                  </h3>
                </div>
                <div className="row">
                  <div className="col-md-3">
                    <Select
                      control={form.control}
                      errors={form.errors}
                      options={ownersSelect}
                      label="Proprietário da Conta"
                      name="user_id"
                    />
                  </div>

                  <div className="col-md-3">
                    <Select
                      control={form.control}
                      errors={form.errors}
                      preValue={"client"}
                      options={[
                        { value: "client", label: "Cliente Envia Boleto" },
                        { value: "bank", label: "Banco Envia Boleto" },
                      ]}
                      label="Envio do Boleto"
                      name="who_sends"
                    />
                  </div>

                  <div className="col-md-2">
                    <NumberInput
                      name="days_to_clean"
                      control={form.control}
                      errors={form.errors}
                      label="Dias para Baixa"
                      max={89}
                    />
                  </div>

                  <div className="col-md-2">
                    <Input
                      name="seq_shipping"
                      control={form.control}
                      errors={form.errors}
                      label="Sequencial Remessa"
                      keyfilter="int"
                      maxLength={6}
                    />
                  </div>
                </div>

                <div className="flex align-items-center pt-5">
                  <h3 className="vertical-align-middle text-success">
                    Dados da conta de Integração
                    <i className="mx-2 bi bi-currency-exchange"></i>
                  </h3>
                </div>
                <div className="row">
                  <div className="col-md-2">
                    <Input
                      name="agency"
                      control={form.control}
                      errors={form.errors}
                      label="Agência"
                      keyfilter="int"
                      maxLength={4}
                      onChange={(e) =>
                        e.target.value.length === 4 &&
                        document
                          .querySelector('input[name="agency_digit"]')
                          .focus()
                      }
                    />
                  </div>

                  <div className="col-md-1">
                    <Input
                      name="agency_digit"
                      control={form.control}
                      errors={form.errors}
                      label="Digito"
                      keyfilter="int"
                      maxLength={1}
                      onChange={(e) =>
                        e.target.value.length === 1 &&
                        document
                          .querySelector('input[name="account_number"]')
                          .focus()
                      }
                    />
                  </div>

                  <div className="col-md-2">
                    <Input
                      name="account_number"
                      control={form.control}
                      errors={form.errors}
                      label="Conta Corrente"
                      keyfilter="int"
                      maxLength={6}
                      onChange={(e) =>
                        e.target.value.length === 6 &&
                        document
                          .querySelector('input[name="account_digit"]')
                          .focus()
                      }
                    />
                  </div>

                  <div className="col-md-1">
                    <Input
                      name="account_digit"
                      control={form.control}
                      errors={form.errors}
                      label="Digito"
                      keyfilter="int"
                      maxLength={1}
                      onChange={(e) =>
                        e.target.value.length === 1 &&
                        document
                          .querySelector('input[name="beneficiary_code"]')
                          .focus()
                      }
                    />
                  </div>

                  <div className="col-md-1">
                    <Input
                      name="beneficiary_code"
                      control={form.control}
                      errors={form.errors}
                      label="Cedente"
                      keyfilter="int"
                      maxLength={2}
                      onChange={(e) =>
                        e.target.value.length === 2 &&
                        document.querySelector('input[name="wallet"]').focus()
                      }
                    />
                  </div>

                  <div className="col-md-1">
                    <Input
                      name="wallet"
                      control={form.control}
                      errors={form.errors}
                      label="Carteira"
                      keyfilter="int"
                      maxLength={2}
                      onChange={(e) =>
                        e.target.value.length === 2 &&
                        document
                          .querySelector('input[name="wallet_variation"]')
                          .focus()
                      }
                    />
                  </div>

                  <div className="col-md-2">
                    <Input
                      name="wallet_variation"
                      control={form.control}
                      errors={form.errors}
                      label="Variação Carteira"
                      keyfilter="int"
                      maxLength={3}
                    />
                  </div>
                </div>

                <hr className="my-4" />

                <div className="col-md-12 text-end">
                  {/* {currentData && !state.edit ? (
                    <Button
                      rounded
                      type="submit"
                      iconPos="right"
                      label={"Próximo"}
                      icon="fa-solid fa-circle-chevron-right"
                      className="p-inputtext-sm m-auto"
                      onClick={() => setActiveIndex(1)}
                    />
                  ) : (
                    <Button
                      rounded
                      type="submit"
                      iconPos="right"
                      label={"Enviar Dados"}
                      icon="fa-solid fa-circle-chevron-right"
                      className="p-inputtext-sm m-auto"
                    />
                  )} */}
                  <Button
                    rounded
                    type="submit"
                    iconPos="right"
                    label={"Enviar Dados"}
                    icon="fa-solid fa-circle-chevron-right"
                    className="p-inputtext-sm m-auto"
                    loading={isLoading}
                  />
                </div>
              </form>
            </TabPanel>
            {/* <TabPanel header="Desconto Boleto" leftIcon="pi pi-dollar mx-2">
              <form onSubmit={form.handleSubmit(onDiscountSubmit)}>
                <div className="flex align-items-center mt-2">
                  <h3 className="vertical-align-middle text-success">
                    Descontos Boleto <i className="bi bi-currency-exchange"></i>
                  </h3>
                </div>
                <div className="row">
                  <div>
                    <p>
                      Configurações de Desconto no Boleto
                      <Tooltip target=".custom-target-icon" />
                      <i
                        className="custom-target-icon pi pi-info-circle mx-2 p-text-secondary"
                        data-pr-tooltip="Caso queira dar algum desconto até a data de vencimento, selecione quantos dias antes do vencimento e o percentual ou valor fixo de desconto."
                        style={{ cursor: "pointer" }}
                      ></i>
                    </p>

                  </div>
                  <div className="row">
                    <div className="col-md-3 d-flex justify-content-between">
                      <div className="pt-4">
                        <RadioButton
                          inputId="ingredient1"
                          name="percent"
                          value="1"
                          checked={radioButton === "1"}
                          onChange={(e) => setRadioButton(e.value)}
                        />
                        <label htmlFor="ingredient1" className="mx-2">
                          Percentual
                        </label>
                      </div>
                      <div className="pt-4">
                        <RadioButton
                          inputId="ingredient1"
                          name="value"
                          value="2"
                          checked={radioButton === "2"}
                          onChange={(e) => setRadioButton(e.value)}
                        />
                        <label htmlFor="ingredient1" className="mx-2">
                          Valor Fixo
                        </label>
                      </div>
                    </div>

                  </div>

                  <div className="row mt-4">
                    <div className="col-md-3">
                      <NumberInput
                        name="value_discount"
                        suffix={radioButton === "1" && "%"}
                        prefix={radioButton === "0" && "R$"}
                        placeholder={radioButton === "1" ? "0%" : "0"}
                        max={100}
                        control={form.control}
                        errors={errors}
                        label={
                          radioButton === "1"
                            ? "% Min. Entrada"
                            : "Valor Fixo Entrada"
                        }
                      />
                    </div>

                    <div className="col-md-4 mt-4">
                      <span className="p-float-label">
                        <NumberInput
                          name="days_discount_payment_slip"
                          max={100}
                          control={form.control}
                          errors={errors}
                          label={"Dias para Desconto Antes do Vencimento"}
                        />
                      </span>
                    </div>
                  </div>

                  <hr className="my-4" />

                  <div className="col-md-12 d-flex justify-content-between">
                    <div>
                      <Button
                        rounded
                        type="submit"
                        label="Anterior"
                        onClick={() => setActiveIndex(0)}
                        severity="secondary"
                        icon="fa-solid fa-circle-chevron-left"
                        className="p-inputtext-sm m-auto"
                      />
                    </div>
                    <div>
                      <Button
                        rounded
                        type="submit"
                        iconPos="right"
                        label="Enviar Dados"
                        icon="fa-solid fa-circle-chevron-right"
                        className="p-inputtext-sm m-auto"
                      />
                    </div>
                  </div>
                </div>
              </form>
            </TabPanel> */}
          </TabView>
        </Panel>
      )}
    </>
  );
}
